import ga4 from "@/lib/tracking/ga4Core";

const JOURNEY_DETAILS = "verify_precise_location";

export const trackRequestPreciseLocation = ({ source }) => {
  const eventName = "click_interaction";
  const eventParams = {
    target: "request_precise_location",
    source,
    journey_details: JOURNEY_DETAILS,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackContinuePreciseLocation = ({ source }) => {
  const eventName = "click_interaction";
  const eventParams = {
    target: "continue",
    source,
    journey_details: JOURNEY_DETAILS,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};
